<template>
  <div>
    <page-header title="Мобильное приложение"/>
    <div class="vz-mobile-application">
      <div id="main" class="vz-mobile-application-main">
        <div class="vz-mobile-application-container">
          <div class="vz-mobile-application-main-data">
            <div
              class="vz-mobile-application-title color-primary"
              v-html="content.blocks?.main.title"
            />
            <div
              class="vz-mobile-application-text"
              v-html="content.blocks?.main.description"
            />
            <div class="flex">
              <a
                href="https://apps.apple.com/ru/app/vozovoz-%D0%B3%D1%80%D1%83%D0%B7%D0%BE%D0%BF%D0%B5%D1%80%D0%B5%D0%B2%D0%BE%D0%B7%D0%BA%D0%B8/id1546357679"
                target="_blank">
                <img src="/svg/as-dark.svg" alt="">
              </a>
              <a href="https://play.google.com/store/apps/details?id=ru.vozovoz.customers" target="_blank">
                <img src="/svg/gp-dark.svg" alt="">
              </a>
            </div>
          </div>
          <img src="/images/pages/mobile-application/vz-mobile-application-main.png"
               class="vz-mobile-application-main-img" alt="">
        </div>
      </div>

      <div id="advantages" class="vz-mobile-application-advantages">
        <div class="vz-mobile-application-container">
          <div class="vz-mobile-application-title">
            {{ content.blocks?.advantages.title }}
          </div>
          <div class="vz-mobile-application-subtitle">
            {{ content.blocks?.advantages.subtitle }}
          </div>
          <div class="vz-mobile-application-cards">
            <div
              v-for="(item, index) in advantagesItems"
              :key="index"
              class="vz-mobile-application-advantages-card"
            >
              <div>
                <div class="vz-mobile-application-advantages-card-title">
                  {{ item.title }}
                </div>
                {{ item.text }}
              </div>
              <img :src="item.img" class="vz-mobile-application-advantages-card-img" alt="">
            </div>
          </div>
        </div>
      </div>

      <div id="everyplace" class="vz-mobile-application-everyplace">
        <div class="vz-mobile-application-container">
          <div class="vz-mobile-application-title color-primary">
            {{ content.blocks?.everyplace.title }}
          </div>
          <div class="vz-mobile-application-subtitle">
            {{ content.blocks?.everyplace.subtitle }}
          </div>
          <div class="vz-mobile-application-cards">
            <div
              v-for="(item, index) in everyplaceItems"
              :key="index"
              class="vz-mobile-application-everyplace-card"
            >
              <div class="vz-mobile-application-everyplace-card-img">
                <img :src="item.img" alt="">
              </div>
              <div class="vz-mobile-application-everyplace-card-data">
                <div class="vz-mobile-application-everyplace-card-title">
                  {{ item.title }}
                </div>
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="vz-mobile-application-mobility">
        <div class="vz-mobile-application-container">
          <img src="/images/pages/mobile-application/vz-mobile-application-mobility.png"
               class="vz-mobile-application-mobility-img" alt="">
          <div class="vz-mobile-application-mobility-data">
            <div class="vz-mobile-application-title">
              {{ content.blocks?.mobility.title }}
            </div>
            <div
              class="vz-mobile-application-text"
              v-html="content.blocks?.mobility.description"
            />
            <div class="flex vz-mobile-application-mobility-links">
              <a href="https://play.google.com/store/apps/details?id=ru.vozovoz.customers" target="_blank">
                <span>
                  <img src="/images/pages/mobile-application/vz-mobile-application-mobility-1.png" alt="">
                </span>
                <div>Доступно в Google Play</div>
                <img src="/svg/gp-dark.svg" class="vz-mobile-application-mobility-links-mb" alt="">
              </a>
              <a
                href="https://apps.apple.com/ru/app/vozovoz-%D0%B3%D1%80%D1%83%D0%B7%D0%BE%D0%BF%D0%B5%D1%80%D0%B5%D0%B2%D0%BE%D0%B7%D0%BA%D0%B8/id1546357679"
                target="_blank">
                <span>
                  <img src="/images/pages/mobile-application/vz-mobile-application-mobility-2.png" alt="">
                </span>
                <div>Доступно в App Store</div>
                <img src="/svg/as-dark.svg" class="vz-mobile-application-mobility-links-mb" alt="">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from "~/components/public/page-header.vue";
import {getPageContent} from "~/api/content";

const content = await getPageContent('/mobile-application')

const advantagesItems = [
  {
    title: content.blocks?.advantagesItems.calculatorTitle,
    text: content.blocks?.advantagesItems.calculatorDescription,
    img: '/images/pages/mobile-application/vz-mobile-application-advantages-1.png'
  },
  {
    title: content.blocks?.advantagesItems.cargoTrackingTitle,
    text: content.blocks?.advantagesItems.cargoTrackingDescription,
    img: '/images/pages/mobile-application/vz-mobile-application-advantages-2.png'
  },
  {
    title: content.blocks?.advantagesItems.addressTitle,
    text: content.blocks?.advantagesItems.addressDescription,
    img: '/images/pages/mobile-application/vz-mobile-application-advantages-3.png'
  },
  {
    title: content.blocks?.advantagesItems.terminalTitle,
    text: content.blocks?.advantagesItems.terminalDescription,
    img: '/images/pages/mobile-application/vz-mobile-application-advantages-4.png'
  }
]

const everyplaceItems = [
  {
    title: content.blocks?.everyplace.fastOrderTitle,
    text: content.blocks?.everyplace.fastOrderDescription,
    img: '/images/pages/mobile-application/vz-mobile-application-place-time-1.png'
  },
  {
    title: content.blocks?.everyplace.paymentTitle,
    text: content.blocks?.everyplace.paymentDescription,
    img: '/images/pages/mobile-application/vz-mobile-application-place-time-2.png'
  },
  {
    title: content.blocks?.everyplace.eventsTitle,
    text: content.blocks?.everyplace.eventsDescription,
    img: '/images/pages/mobile-application/vz-mobile-application-place-time-3.png'
  }
]
</script>
